import React from 'react';
import { QueryClientProvider, QueryClient } from 'react-query';
import { QueryClientConfig, RFCP } from '../types';

type Props = {
  config?: QueryClientConfig;
};

export const DefaultQueryClientProvider: RFCP<Props> = ({
  children,
  // TODO default query client config
  config = {},
}) => {
  const [client] = React.useState(new QueryClient(config));
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>;
};
